"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAltText = exports.getGifWidth = exports.getGifHeight = exports.getBestRenditionUrl = exports.getBestRendition = exports.getBestVideo = exports.getSpecificRendition = void 0;
var bestfit_1 = __importDefault(require("./bestfit"));
var collections_1 = require("./collections");
var webp_check_1 = require("./webp-check");
var getSpecificRendition = function getSpecificRendition(_a, renditionLabel, isStill, useVideo) {
  var images = _a.images,
    isSticker = _a.is_sticker;
  if (isStill === void 0) {
    isStill = false;
  }
  if (useVideo === void 0) {
    useVideo = false;
  }
  if (!images || !renditionLabel) return '';
  isStill = isStill && !useVideo;
  // @ts-ignore come back to this
  var rendition = images["".concat(renditionLabel).concat(isStill ? '_still' : '')];
  if (rendition) {
    if (isSticker || isStill) {
      return rendition.url;
    }
    var webP = webp_check_1.SUPPORTS_WEBP && rendition.webp;
    return useVideo ? rendition.mp4 : webP || rendition.url;
  }
  return '';
};
exports.getSpecificRendition = getSpecificRendition;
var getBestVideo = function getBestVideo(video, width, height) {
  var assets = video === null || video === void 0 ? void 0 : video.assets;
  if (assets) {
    assets = __assign({}, assets);
    // @ts-ignore we don't show source according to the existing code
    delete assets.source;
    var filteredAssets = Object.values(assets).sort(function (a, b) {
      return a.width - b.width;
    });
    return (0, bestfit_1.default)(filteredAssets, width, height);
  }
};
exports.getBestVideo = getBestVideo;
var getRenditions = function getRenditions(type, images, video) {
  return type === 'video' && video && video.previews && !Object.keys(images).length ? video.previews : images;
};
var getBestRendition = function getBestRendition(images, gifWidth, gifHeight, scaleUpMaxPixels) {
  var checkRenditions = (0, collections_1.pick)(images, ['original', 'fixed_width', 'fixed_height', 'fixed_width_small', 'fixed_height_small']);
  var testImages = Object.entries(checkRenditions).map(function (_a) {
    var renditionName = _a[0],
      val = _a[1];
    return __assign({
      renditionName: renditionName
    }, val);
  });
  return (0, bestfit_1.default)(testImages, gifWidth, gifHeight, scaleUpMaxPixels);
};
exports.getBestRendition = getBestRendition;
var getBestRenditionUrl = function getBestRenditionUrl(_a, gifWidth, gifHeight, options) {
  var images = _a.images,
    video = _a.video,
    type = _a.type;
  if (options === void 0) {
    options = {
      isStill: false,
      useVideo: false
    };
  }
  if (!gifWidth || !gifHeight || !images) return '';
  var useVideo = options.useVideo,
    isStill = options.isStill,
    scaleUpMaxPixels = options.scaleUpMaxPixels;
  var renditions = getRenditions(type, images, video);
  var renditionName = (0, exports.getBestRendition)(renditions, gifWidth, gifHeight, scaleUpMaxPixels).renditionName;
  // still, video, webp or gif
  var key = "".concat(renditionName).concat(isStill && !useVideo ? '_still' : '');
  var rendition = renditions[key];
  var match = useVideo ? rendition.mp4 : webp_check_1.SUPPORTS_WEBP && rendition.webp ? rendition.webp : rendition.url;
  return match || '';
};
exports.getBestRenditionUrl = getBestRenditionUrl;
var getGifHeight = function getGifHeight(_a, gifWidth) {
  var images = _a.images;
  var fixed_width = images.fixed_width;
  if (fixed_width) {
    var width = fixed_width.width,
      height = fixed_width.height;
    var aspectRatio = width / height;
    return Math.round(gifWidth / aspectRatio);
  }
  return 0;
};
exports.getGifHeight = getGifHeight;
var getGifWidth = function getGifWidth(_a, gifHeight) {
  var images = _a.images;
  var fixed_width = images.fixed_width;
  if (fixed_width) {
    var width = fixed_width.width,
      height = fixed_width.height;
    var aspectRatio = width / height;
    return Math.round(gifHeight * aspectRatio);
  }
  return 0;
};
exports.getGifWidth = getGifWidth;
/**
 * GIF Text - Alt Text: Generates alt text for
 * GIF images based on username and tags.
 * @prop  {Gif}
 * @return {String} GIF alt text.
 */
var getAltText = function getAltText(_a) {
  var alt_text = _a.alt_text,
    user = _a.user,
    _b = _a.tags,
    tags = _b === void 0 ? [] : _b,
    _c = _a.is_sticker,
    is_sticker = _c === void 0 ? false : _c,
    _d = _a.title,
    title = _d === void 0 ? '' : _d;
  if (alt_text) {
    return alt_text;
  }
  if (title) {
    return title;
  }
  var username = user && user.username || '';
  var filteredTags = (0, collections_1.take)((0, collections_1.without)(tags, ['transparent']), username ? 4 : 5);
  return "".concat(username ? "".concat(username, " ") : "").concat(filteredTags.join(' '), " ").concat(is_sticker ? 'Sticker' : 'GIF');
};
exports.getAltText = getAltText;